import { useSelector } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { isWguExperience } from 'reports/cw/helpers/wgu.helper';
var useWguExperience = function () {
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var courseId = useSelector(appSelectors.getSelectedCourse);
    var courseSectionInfo = useSelector(courseSelectors.getCourseSectionInfo);
    return isWguExperience(courseSectionInfo, featureFlags, courseId);
};
export default useWguExperience;
